import * as React from 'react'

import AccmeLogoIcon from 'ui-component-library/icons/accme-accredited-logo.svg'

import style from './style.scss'

type Props = {
  ariaLabel?: string
} & React.HTMLAttributes<HTMLDivElement>

function AccmeLogo({ ariaLabel, className }: Props) {
  return (
    <div className={className}>
      <AccmeLogoIcon aria-label={ariaLabel} role='img' className={style.logo} />
    </div>
  )
}

export default AccmeLogo
